import React, { useState, useEffect, useCallback } from 'react'
import { Box, Checkbox, ListItemText, MenuItem, Typography, Button, Modal, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import SaveIcon from '@mui/icons-material/Save'
import { mainGreen, mainGrey, mainRed } from '../utils/color'
import { socket } from '../utils/socket'
import { getFromStorage } from '../utils/storage'
import { fetchTags } from '../utils/tagUtils'
import { useSelector } from 'react-redux'
import { selectStores } from '../redux/slices/storeSlice'
import CloseIcon from '@mui/icons-material/Close'

export default function TagModal({ open, onClose, currentItem }) {
	const [selectedTags, setSelectedTags] = useState([])
	const [tags, setTags] = useState([])
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((s) => s.currentUser)
	const storesFromRedux = useSelector(selectStores)
	const storeId = currentUser?.store || storesFromRedux?.[0]?._id

	const getTags = useCallback(async () => {
		if (!storeId) return
		try {
			const response = await fetchTags(storeId)
			setTags(response || [])
		} catch (error) {
			console.log(error.response?.data?.message)
		}
	}, [storeId])

	useEffect(() => {
		if (currentItem) {
			setSelectedTags(currentItem?.tag || [])
		}
	}, [currentItem])

	useEffect(() => {
		if (open) {
			getTags()
		}
	}, [open, getTags])

	const isTagSelected = (tagName) => {
		return selectedTags.some((tag) => tag.name?.trim() === tagName?.trim())
	}

	const handleDelete = (e) => {
		e.stopPropagation()
		const confirm = window.confirm('Xóa toàn bộ tag?')
		if (confirm) {
			socket.emit('post-create-tag', {
				tagArray: [],
				orderId: currentItem._id,
				accessToken: token,
				store: currentUser?.store,
				creator: currentUser,
				serviceIndex: currentItem.serviceIndex,
			})
			onClose()
		}
	}

	const handleUpdate = (e) => {
		e.stopPropagation()
		socket.emit('post-create-tag', {
			tagArray: selectedTags,
			orderId: currentItem._id,
			accessToken: token,
			store: currentUser?.store,
			creator: currentUser,
			serviceIndex: currentItem.serviceIndex,
		})
		onClose()
	}

	const handleMenuItemClick = (e, tag) => {
		e.stopPropagation()
		const isSelected = isTagSelected(tag.name)

		if (isSelected) {
			setSelectedTags(selectedTags.filter((t) => t.name !== tag.name))
		} else {
			setSelectedTags([...selectedTags, { name: tag.name, color: tag.color }])
		}
	}

	return (
		<Modal open={open} onClose={onClose} sx={styles.modal}>
			<Box sx={styles.content}>
				<Box sx={styles.header}>
					<Box sx={styles.headerContent}>
						<Typography sx={styles.title}>
							Tag đơn {currentItem?.shiftCode}
							{currentItem?.shiftIndex} - {currentItem?.shiftDay}
						</Typography>
						<IconButton onClick={onClose} sx={styles.closeIcon}>
							<CloseIcon />
						</IconButton>
					</Box>
				</Box>
				<Box sx={styles.list}>
					{tags?.map((tag, index) => (
						<MenuItem
							key={index}
							onClick={(e) => {
								e.stopPropagation()
								handleMenuItemClick(e, tag)
							}}
							sx={{
								cursor: 'pointer',
								'&:hover': {
									backgroundColor: 'rgba(0, 0, 0, 0.04)',
								},
							}}>
							<Checkbox checked={isTagSelected(tag.name)} value={tag.name} sx={{ pointerEvents: 'none' }} />
							<ListItemText
								primary={tag.name}
								sx={{
									'& .MuiTypography-root': { color: tag.color || 'inherit' },
								}}
							/>
						</MenuItem>
					))}
				</Box>
				<Box sx={styles.footer}>
					<Button
						variant='contained'
						startIcon={<SaveIcon />}
						onClick={handleUpdate}
						sx={{
							bgcolor: mainGreen,
							'&:hover': { bgcolor: mainGreen },
							textTransform: 'none',
							fontSize: '0.875rem',
						}}>
						Cập nhật
					</Button>
					<Button
						variant='contained'
						startIcon={<DeleteIcon />}
						onClick={handleDelete}
						sx={{
							bgcolor: mainRed,
							'&:hover': { bgcolor: mainRed },
							textTransform: 'none',
							fontSize: '0.875rem',
						}}>
						Xóa hết
					</Button>
				</Box>
			</Box>
		</Modal>
	)
}

const styles = {
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	content: {
		background: mainGrey,
		border: `2px solid ${mainGreen}`,
		borderRadius: '1rem',
		boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
		width: '100%',
		maxWidth: '500px',
		maxHeight: '50vh',
		position: 'relative',
		mx: 2,
	},
	header: {
		p: 2,
		borderBottom: '1px solid #e0e0e0',
		bgcolor: 'background.paper',
		borderTopLeftRadius: '16px',
		borderTopRightRadius: '16px',
	},
	headerContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	title: {
		fontSize: '1rem',
		fontWeight: 500,
	},
	closeIcon: {
		cursor: 'pointer',
		color: '#666',
	},
	list: {
		maxHeight: 'calc(50vh - 120px)',
		overflowY: 'auto',
	},
	item: {
		display: 'flex',
		alignItems: 'center',
		py: 0.5,
	},
	footer: {
		p: 2,
		borderTop: '1px solid #e0e0e0',
		bgcolor: 'background.paper',
		borderBottomLeftRadius: '16px',
		borderBottomRightRadius: '16px',
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 2,
	},
	button: {
		color: mainGreen,
		textTransform: 'none',
	},
}
